import React from 'react'
import styles from './BottomBar.scss'
import {SingleLineEditor} from 'common/SingleLineEditor'
import cx from 'classnames'
import fetchJSON from 'lib/fetchJSON'
import {Button} from 'common/Button'
import {Icon} from 'common/LegacyIcon'
import {CircleSpinner} from 'common/spinners'
import smartDate from '@qrohlf/smart-date'
import {photoFull} from 'lib/urlHelpers'
const preventDefault = e => e.preventDefault()

export class BottomBar extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      captionHasFocus: false
    }
  }

  onCaptionFocus = () => {
    this.setState({captionHasFocus: true})
  }

  onCaptionBlur = () => {
    this.setState({captionHasFocus: false})
  }

  render () {
    const {readonly, photo, onCaptionChange, onDelete, rotating, onRotate, onRotateComplete, photosetId, parentType, parentId, coverId, onSetCover} = this.props
    const {captionHasFocus} = this.state

    return (
      <div className={styles.BottomBar}>
        <div className={styles.left}>
          {photo.captured_at && smartDate(typeof photo.captured_at === 'string' ? photo.captured_at : photo.captured_at.toISOString())}
          {photo.parent_type === 'trip' && <a href={`/trips/${photo.parent_id}`} className={styles.tripLink}>(go to ride)</a>}
          {photo.parent_type === 'route' && <a href={`/routes/${photo.parent_id}`} className={styles.tripLink}>(go to route)</a>}
        </div>
        {readonly
          ? (photo.caption && <p className={styles.caption}>{photo.caption}</p>)
          : <CaptionEditor
            photo={photo}
            key={`${photo.id}-caption`}
            onRotate={onRotate}
            onFocus={this.onCaptionFocus}
            onBlur={this.onCaptionBlur}
            hasFocus={captionHasFocus}
            onRotateComplete={onRotateComplete}
            onCaptionChange={onCaptionChange}
            rotating={rotating} />}
        <div className={styles.right}>
          {!readonly && <Toolbox photo={photo}
            onRotate={onRotate}
            onRotateComplete={onRotateComplete}
            onDelete={onDelete}
            photosetId={photosetId}
            parentType={parentType}
            parentId={parentId}
            coverId={coverId}
            captionHasFocus={captionHasFocus}
            onSetCover={onSetCover} />}
        </div>
      </div>
    )
  }
}

class Toolbox extends React.Component {
  onRotateLeft = () => {
    this.rotate(-90)
  }

  onRotateRight = () => {
    this.rotate(90)
  }

  rotate = (degrees) => {
    const {photo} = this.props
    this.props.onRotate()
    fetchJSON(`/photos/${photo.id}/rotate.json`, {degrees})
      .then(() => {
        this.props.onRotateComplete()
      })
  }

  onDelete = () => {
    if (window.confirm('Are you sure you want to delete this photo?')) {
      this.props.onDelete()
    }
  }

  onSetHighlight = (photoId) => {
    const {photo, onSetCover} = this.props
    onSetCover(photo.id)
    fetchJSON(`/photos/${photoId}/highlight.json`, {}, {method: 'POST'})
  }

  render () {
    const {photo, coverId, photosetId, captionHasFocus} = this.props
    const photosetButton = photo.id === coverId
      ? <span className={styles.coverLink}>cover image</span>
      : <a onClick={() => this.onSetHighlight(photo.id)} className={styles.coverLink}>set as cover</a>
    return (
      <div className={styles.toolbox}>
        {photosetId && !captionHasFocus && photosetButton}
        <Icon i='rotateLeft' size={18} onClick={this.onRotateLeft} />
        <Icon i='rotateRight' size={18} onClick={this.onRotateRight} />
        <a href={photoFull(photo.id)} alt='Download original' download={`${photo.id}.jpg`} title='download original'><Icon i='download' size={18} /></a>
        <Icon i='trash' size={18} onClick={this.onDelete} />
      </div>
    )
  }
}

class CaptionEditor extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      caption: props.caption,
      saving: false
    }
  }

  onChange = (caption) => {
    this.setState({caption})
  }

  saveCaption = () => {
    const {photo, onCaptionChange} = this.props
    const {caption} = this.state

    onCaptionChange(caption)

    this.setState({saving: true})
    fetchJSON('/photos/update_set.json', {
      photos: {
        [photo.id]: {caption}
      }
    }).then(() => {
      // make sure we show spinner for at least 1 second
      setTimeout(() => {
        this.setState({saving: false})
        this._editor && this._editor.blur()
      }, 1000)
    })
  }

  setRef = (editor) => {
    this._editor = editor
  }

  render () {
    const {saving} = this.state
    const {photo, hasFocus} = this.props

    return (
      <div className={cx(styles.caption, styles.captionEditor, hasFocus && styles.hasFocus)}>
        <SingleLineEditor
          ref={this.setRef}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          defaultValue={photo.caption}
          placeholder='Click to add a caption'
          onChange={this.onChange}
          onReturn={this.saveCaption}
          textAlignment='center' />
        {hasFocus && !saving && <Button onClick={this.saveCaption} className={styles.saveButton} onMouseDown={preventDefault}>save</Button>}
        {saving && <CircleSpinner size={14} className={styles.saveSpinner} />}
      </div>
    )
  }
}
